<template>
  <v-dialog v-model="apiError" fullscreen>
    <v-card class="dialog--full">
      <div class="api-error-page container text-center">
        <v-icon color="#EA0B40" size="60px">mdi-alert-circle</v-icon>
        <h1 class="my-3">Sorry, something has gone wrong</h1>
        <p class="secondary-text px-10">
          We’re experiencing a system issue which has been logged for
          investigation. Please contact us if this issue persists.
        </p>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState("auth", {
      apiError: state => state.apiError
    })
  }
};
</script>

<style lang="scss">
.secondary-text {
  color: #686868;
}
.api-error-page {
  padding-top: 80px;
}
</style>
